import axios from 'axios'

/**
 *
 * @param {pbject} payload
 * @returns
 */
export const getCandidateList = async (payload) => {
  const response = await axios.post(`candidates/list`, payload)
  return response
}

/**
 *
 * @param {object} payload // {"candidateId": 70,  "workspaceId": 4}
 * @returns
 */
export const getCandidateDetails = async (payload) => {
  const response = await axios.post(`candidates/contests`, payload)
  return response
}

/**
 * 
 * @param {obj} payload  // {
  "workspaceId": 4,
  "contestId":780,
  "candidateId":70,
  "fieldId": null 
}
 */
export const downloadCandidateResume = async (payload) => {
  const response = await axios.post(`candidates/resume/download`, payload, {
    responseType: 'blob'
  })
  return response
}
